export const septemberAbbreviatedLowercase = "fMhbFe";
export default {septemberAbbreviatedLowercase};